class Wysiwyg {
  constructor(root) {
    this.root = root;
    this.tables = this.root.querySelectorAll('table');

    this.init();
  }

  init() {
    this.tables.forEach(table => {
      table.classList.add('custom-table');

      table.removeAttribute('style');
      table.removeAttribute('width');
      table.removeAttribute('height');

      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');
      const titles = [...thead.querySelectorAll('td')].map(el => el.innerHTML);
      const rows = [...tbody.querySelectorAll('tr')];

      const mobile = document.createElement('div');
      mobile.classList.add('custom-table-mobile');

      rows.forEach(row => {
        const elMobileRow = document.createElement('div');
        elMobileRow.classList.add('custom-table-mobile__row');
        const tds = [...row.querySelectorAll('td')];

        tds.forEach((td, index) => {
          const elMobileCell = document.createElement('div');
          elMobileCell.classList.add('custom-table-mobile__cell');
          const title = titles[index];
          elMobileCell.innerHTML = `<strong>${title}:</strong> ${td.innerHTML}`;

          elMobileRow.appendChild(elMobileCell);
        });

        mobile.appendChild(elMobileRow);
      });

      table.after(mobile);
    });
  }

  destroy() {
  }
}

export default {
  when() {
    return document.querySelectorAll('[data-wysiwyg]').length > 0
  },

  created() {
    this.instances = [];
    document.querySelectorAll('[data-wysiwyg]').forEach(root => {
      const instance = new Wysiwyg(root);
      this.instances.push(instance);
    });
  },

  destroyed() {
    this.instances.forEach(instance => {
      instance.destroy && instance.destroy();
    });
  }
}
